import moment from 'moment';

import { Http } from '../../../support';

const to = moment().format('YYYY-MM-DD');
const from = moment().subtract(1, 'months').format('YYYY-MM-DD');

export const initialState = {
  busy: false,
  data: [],
  selectedRows: [],
  selectedRowKeys: [],
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
    from,
    to,
  },
};

const setSelectedRows = (store, data) => {
  store.setState((state) => {
    state.modulo.autofacturacion.tickets = {
      ...state.modulo.autofacturacion.tickets,
      ...data,
    };
  });
};

const change = (store, data) => {
  store.setState((state) => {
    state.modulo.autofacturacion.tickets.data = {
      ...state.modulo.autofacturacion.tickets.data,
      ...data,
    };
  });
};

const paginate = async (store, params) => {
  store.setState((state) => {
    state.modulo.autofacturacion.tickets = {
      ...state.modulo.autofacturacion.tickets,
      busy: true,
      pagination: {
        ...state.modulo.autofacturacion.tickets.pagination,
        ...params,
      },
    };
  });

  try {
    const { pagination } = store.state.modulo.autofacturacion.tickets;

    const body = {
      ...pagination,
      ...params,
      include: ['tracking'],
    };

    const response = await Http.get(`/api/autofacturacion/tickets`, { params: body });

    store.setState((state) => {
      state.modulo.autofacturacion.tickets = {
        ...state.modulo.autofacturacion.tickets,
        busy: false,
        data: response.data,
        pagination: {
          ...state.modulo.autofacturacion.tickets.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.autofacturacion.tickets.busy = false;
      state.modulo.autofacturacion.tickets.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.modulo.autofacturacion.tickets = {
      ...initialState,
    };
  });
};

const AutofacturacionTicketListStore = {
  state: () => initialState,
  actions: {
    change,
    setSelectedRows,
    paginate,
    reset,
  },
};

export default AutofacturacionTicketListStore;
